import React, { useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "../components/style.css";
import AlertMessage from "../AlertMessage";
import StatesDataMarathi from './StatesDataMarathi.json'
import StatesDataEnglish from './StatesDataEnglish.json'

function SchoolData() {

  const language = localStorage.getItem('language') || 'English';

  const [formData, setFormData] = useState({
    schoolName: "",
    udiseNumber: "",
    password: "",
    mobileNumber: "",
    language: "",
    telephoneNumber: "",
    address: "",
    taluka: "",
    jilha: "",
    state: language === "English" ? "Maharashtra" : 'महाराष्ट्र',
    email: "",
    pincode: "",
    sansthaName: "",
    bridvakya: "",
    boardName: "",
    indexNumber: "",
    schoolCode: "",
    sanlagnataKramank: "",
    manyataKramank: "",
    madhyam: "",
    schoolLogo: "",
    schoolLogo2: "",
  });
  const [logoFile, setLogoFile] = useState(null);
  const [logoURL, setLogoURL] = useState(null);

  const [logoFile2, setLogoFile2] = useState(null);
  const [logoURL2, setLogoURL2] = useState(null);

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);


  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [showForm, setShowForm] = useState(false);

  const [signatureFile, setSignatureFile] = useState(null);
  const [signatureURL, setSignatureURL] = useState(null);


  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    // Set districts and talukas based on the default state when the component mounts
    const defaultState = formData.state;
    const statesData = language === 'English' ? StatesDataEnglish : StatesDataMarathi;
    if (statesData[defaultState]) {
      setDistricts(statesData[defaultState].districts);
      // Set the talukas based on the first district if available
      const firstDistrict = statesData[defaultState].districts[0];
      if (firstDistrict && statesData[defaultState].talukas[firstDistrict]) {
        setTalukas(statesData[defaultState].talukas[firstDistrict]);
        setFormData((prevData) => ({
          ...prevData,
          jilha: firstDistrict, // Set the first district as default
          taluka: statesData[defaultState].talukas[firstDistrict][0] || "", // Set the first taluka as default
        }));
      }
    }
  }, [formData.state, language]);


  const fetchAllData = () => {
    const udiseNumber = localStorage.getItem("udiseNumber");

    // 1. Fetch Department List
    fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department.json`)
      .then((response) => response.json())
      .then((deptData) => {
        if (deptData) {
          // department.json is likely an object where keys are department names, or an array
          // Based on previous logs/code, we expect an object.
          const departmentKeys = Object.keys(deptData);
          setDepartments(departmentKeys);
        }
      })
      .catch((error) => console.error("Error fetching departments:", error));

    // 2. Fetch School Data (General)
    fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`)
      .then((response) => response.json())
      .then((data) => {
        if (!data) return;

        // Load general school data by default
        setSelectedDepartment(null);
        setFormData({
          ...data,
          udiseNumber,
        });
        setLogoURL(data.schoolLogo || "");
        setLogoURL2(data.schoolLogo2 || "");
        setSignatureURL(data.signature || "");


        // Set districts and talukas based on the saved state and district
        const statesData = language === 'English' ? StatesDataEnglish : StatesDataMarathi;
        const savedState = data.state;
        const savedDistrict = data.jilha;
        const savedTaluka = data.taluka; // Get the saved taluka

        if (statesData[savedState]) {
          setDistricts(statesData[savedState].districts);

          // Set the saved district
          if (savedDistrict) {
            setFormData((prevData) => ({
              ...prevData,
              jilha: savedDistrict,
            }));

            // Set the talukas based on the saved district
            if (statesData[savedState].talukas[savedDistrict]) {
              setTalukas(statesData[savedState].talukas[savedDistrict]);

              // Set the saved taluka instead of the first one
              setFormData((prevData) => ({
                ...prevData,
                taluka: savedTaluka || "", // Use the saved taluka
              }));
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching school data:", error);
      });
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    setLogoFile(file);
  };
  const handleLogoChange2 = (e) => {
    const file = e.target.files[0];
    setLogoFile2(file);
  };

  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      state: selectedState,
      jilha: "", // Reset district when state changes
      taluka: "" // Reset taluka when state changes
    }));

    const statesData = language === 'English' ? StatesDataEnglish : StatesDataMarathi;
    if (statesData[selectedState]) {
      setDistricts(statesData[selectedState].districts);
      setTalukas([]); // Reset talukas when state changes
    } else {
      setDistricts([]); // Reset districts if state is not found
      setTalukas([]); // Reset talukas as well
    }
  }


  const handleDistrictChange = (event) => {
    const selectedDistrict = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      jilha: selectedDistrict,
    }));
    // Update talukas based on selected district
    const selectedState = formData.state;
    const statesData = language === 'English' ? StatesDataEnglish : StatesDataMarathi;
    if (statesData[selectedState]?.talukas?.[selectedDistrict]) {
      setTalukas(statesData[selectedState].talukas[selectedDistrict]);
    } else {
      setTalukas([]); // Reset talukas if district is not found
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const udiseNumber = localStorage.getItem("udiseNumber");

    // Fetch mobile number from school data
    fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {


        // Save form data
        const storageRef = firebase.storage().ref();
        const uploadPromises = [];

        if (logoFile) {
          const uploadTask = storageRef.child(`logos/${udiseNumber}logo`).put(logoFile);
          uploadPromises.push(uploadTask.then(() => uploadTask.snapshot.ref.getDownloadURL()));
        } else {
          uploadPromises.push(Promise.resolve(logoURL)); // Use existing logoURL if no new file
        }

        if (logoFile2) {
          const uploadTask2 = storageRef.child(`logos/${udiseNumber}logo2`).put(logoFile2);
          uploadPromises.push(uploadTask2.then(() => uploadTask2.snapshot.ref.getDownloadURL()));
        } else {
          uploadPromises.push(Promise.resolve(logoURL2)); // Use existing logoURL2 if no new file
        }

        // Signature
        if (signatureFile) {
          const uploadTask3 = storageRef.child(`signatures/${udiseNumber}signature`).put(signatureFile);
          uploadPromises.push(uploadTask3.then(() => uploadTask3.snapshot.ref.getDownloadURL()));
        } else {
          uploadPromises.push(Promise.resolve(signatureURL));
        }

        Promise.all(uploadPromises)
          .then(([newLogoURL, newLogoURL2, newSignatureURL]) => {
            saveFormData(newLogoURL, newLogoURL2, newSignatureURL);
          })

          .catch((error) => {
            console.error("Error uploading logos:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching school data:", error);
      });
  };

  const saveFormData = (logoURL, logoURL2, signatureURL) => {
    const udiseNumber = localStorage.getItem("udiseNumber");
    const bodyData = {
      ...formData,
      schoolLogo: logoURL,
      schoolLogo2: logoURL2,
      signature: signatureURL
    };

    // Remove udiseNumber from the data we're saving to avoid duplication
    const { udiseNumber: _, ...dataToSave } = bodyData;

    if (selectedDepartment) {
      // For department data, we need to update both the department-specific data
      // and potentially the main school data (for shared fields)
      const updates = {
        [`schoolRegister/${udiseNumber}/schoolData/department/${selectedDepartment}`]: dataToSave,
        // Update shared fields in main school data if needed
      };

      fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/.json`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updates),
      })
        .then(() => {
          setAlertMessage("Data Saved Successfully");
          updateIndexedDB(formData, logoURL, logoURL2, signatureURL);  // Add signatureURL here
          window.location.href = "/home";
        })
        .catch((error) => {
          console.error("Error saving school data:", error);
        });
    } else {
      // For general school data
      fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSave),
      })
        .then(() => {
          setAlertMessage("Data Saved Successfully");
          updateIndexedDB(formData, logoURL, logoURL2, signatureURL);  // Add signatureURL here
          window.location.href = "/home";
        })
        .catch((error) => {
          console.error("Error saving school data:", error);
        });
    }
  };

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      try {
        const request = indexedDB.open('SchoolManagementDB', 1);

        request.onerror = (event) => {
          event.preventDefault();
          console.error("IndexedDB error:", event.target.error);
          reject("Error opening IndexedDB");
        };

        request.onsuccess = (event) => {
          resolve(event.target.result);
        };

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('studentData')) {
            db.createObjectStore('studentData', { keyPath: 'id' });
          }
          if (!db.objectStoreNames.contains('schoolData')) {
            db.createObjectStore('schoolData', { keyPath: 'udiseNumber' });
          }
        };
      } catch (err) {
        console.error("Synchronous error opening IndexedDB:", err);
        reject(err);
      }
    });
  };

  const updateIndexedDB = (formData, logoURL, logoURL2, signatureURL) => {  // Add signatureURL parameter
    openIndexedDB().then((db) => {
      const transaction = db.transaction(['schoolData'], 'readwrite');
      const objectStore = transaction.objectStore('schoolData');

      // Select only the fields to be saved in IndexedDB
      const updatedData = {
        boardName: formData.boardName,
        boardType: formData.boardType || "",
        email: formData.email,
        pincode: formData.pincode || "",
        indexNumber: formData.indexNumber,
        schoolCode: formData.schoolCode || "",
        jilha: formData.jilha,
        madhyam: formData.madhyam,
        manyataKramank: formData.manyataKramank,
        mobileNumber: formData.mobileNumber,
        sanlagnataKramank: formData.sanlagnataKramank,
        sansthaName: formData.sansthaName,
        schoolLogo: logoURL,
        schoolLogo2: logoURL2,
        signature: signatureURL,  // Use the passed signatureURL parameter
        schoolName: formData.schoolName,
        taluka: formData.taluka,
        udiseNumber: formData.udiseNumber,
        department: selectedDepartment || null
      };

      const request = objectStore.put(updatedData);
      request.onsuccess = () => {
        console.log("School data updated in IndexedDB successfully.");
      };
      request.onerror = (event) => {
        console.error("Error updating school data in IndexedDB:", event.target.error);
      };
    }).catch((error) => {
      console.error("Error opening IndexedDB:", error);
    });
  };

  const handleSignatureChange = (e) => {
    const file = e.target.files[0];
    setSignatureFile(file);
  };



  return (
    <div>

      <AlertMessage message={alertMessage} show={showAlert} />
      <div className="main-content-of-page overflow-auto mt-5 pt-sm-5 mb-5" style={{ flex: "1" }}>
        <h2 className="mt-3 mb-4 text-center" style={{ color: '#03365e', fontSize: '25px' }}><b>{language === "English" ? " Fill School Information" : "शाळेची माहिती भरा"}</b></h2>



        {departments.length > 0 && (
          <div className="mb-4 d-flex flex-wrap gap-3 justify-content-center">
            {/* General School Data Box */}
            <div
              onClick={() => {
                setSelectedDepartment(null);
                const udiseNumber = localStorage.getItem("udiseNumber");
                fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`)
                  .then((res) => res.json())
                 .then((data) => {
                    if (data) {
                      setFormData({ ...data, udiseNumber });
                      setLogoURL(data.schoolLogo);
                      setLogoURL2(data.schoolLogo2);
                    }
                  });
              }}
              style={{
                cursor: 'pointer',
                padding: '15px 25px',
                borderRadius: '8px',
                backgroundColor: !selectedDepartment ? '#03365e' : '#f8f9fa',
                color: !selectedDepartment ? '#ffffff' : '#03365e',
                border: '1px solid #03365e',
                boxShadow: !selectedDepartment ? '0 4px 6px rgba(0,0,0,0.1)' : 'none',
                transition: 'all 0.3s ease',
                fontWeight: '600',
                minWidth: '150px',
                textAlign: 'center'
              }}
            >
              {language === "English" ? "General School Data" : "सामान्य शाळा माहिती"}
            </div>

            {/* Dynamic Department Boxes */}
            {departments.map((dept) => (
              <div
                key={dept}
                onClick={() => {
                  setSelectedDepartment(dept);
                  const udiseNumber = localStorage.getItem("udiseNumber");
                  fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData/department/${dept}.json`)
                    .then((res) => res.json())
                    .then((data) => {
                      if (data) {
                        setFormData({ ...data, udiseNumber });
                        setLogoURL(data.schoolLogo);
                        setLogoURL2(data.schoolLogo2);
                      } else {
                        // If no data for this department, load general school data as template
                        fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`)
                          .then((res) => res.json())
                          .then((generalData) => {
                            if (generalData) {
                              setFormData({ ...generalData, udiseNumber });
                              setLogoURL(generalData.schoolLogo);
                              setLogoURL2(generalData.schoolLogo2);
                            }
                          });
                      }
                    });
                }}
                style={{
                  cursor: 'pointer',
                  padding: '15px 25px',
                  borderRadius: '8px',
                  backgroundColor: selectedDepartment === dept ? '#03365e' : '#f8f9fa',
                  color: selectedDepartment === dept ? '#ffffff' : '#03365e',
                  border: '1px solid #03365e',
                  boxShadow: selectedDepartment === dept ? '0 4px 6px rgba(0,0,0,0.1)' : 'none',
                  transition: 'all 0.3s ease',
                  fontWeight: '600',
                  minWidth: '150px',
                  textAlign: 'center'
                }}
              >
                {dept}
              </div>
            ))}
          </div>
        )}





        <form onSubmit={handleSubmit} style={{ maxWidth: '900px', margin: '0 auto', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.4)', backgroundColor: '#ffffff' }}>
          <div className="mb-3 ">
            <label htmlFor="schoolName" className="form-label">{language === "English" ? "School Name" : "शाळेचे नाव"}:</label>
            <input
              autoComplete="off"
              type="text"
              className="form-control"
              id="schoolName"
              name="schoolName"
              value={formData.schoolName}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="udiseNumber" className="form-label">{language === "English" ? "UDISE Number" : "UDISE क्र"}:</label>
            <input
              type="text"
              className="form-control"
              id="udiseNumber"
              name="udiseNumber"
              value={formData.udiseNumber}
              readOnly
            />
          </div>
          <div className="mb-3">
            <label htmlFor="mobileNumber" className="form-label">{language === "English" ? "Mobile Number" : "मोबाईल नंबर"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="mobileNumber"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleInputChange}
              inputMode="numeric"
              maxLength={10} readOnly
            />
          </div>
          <div className="mb-3">
            <label htmlFor="address" className="form-label">{language === "English" ? "Village" : "गाव"}:</label>
            <input
              autoComplete="off"
              type="text"
              className="form-control"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="state" className="form-label">{language === "English" ? "State" : "राज्य"}:</label>
            <select
              id="state"
              name="state"
              value={formData.state}
              onChange={handleStateChange}
              className="form-control"
              required
            >
              <option value={language === 'English' ? 'Andhra Pradesh' : 'आंध्र प्रदेश'}>{language === 'English' ? 'Andhra Pradesh' : 'आंध्र प्रदेश'}</option>
              <option value={language === 'English' ? 'Arunachal Pradesh' : 'अरुणाचल प्रदेश'}>{language === 'English' ? 'Arunachal Pradesh' : 'अरुणाचल प्रदेश'}</option>
              <option value={language === 'English' ? 'Assam' : 'असम'}>{language === 'English' ? 'Assam' : 'असम'}</option>
              <option value={language === 'English' ? 'Bihar' : 'बिहार'}>{language === 'English' ? 'Bihar' : 'बिहार'}</option>
              <option value={language === 'English' ? 'Chhattisgarh' : 'छत्तीसगढ़'}>{language === 'English' ? 'Chhattisgarh' : 'छत्तीसगढ़'}</option>
              <option value={language === 'English' ? 'Goa' : 'गोवा'}>{language === 'English' ? 'Goa' : 'गोवा'}</option>
              <option value={language === 'English' ? 'Gujarat' : 'गुजरात'}>{language === 'English' ? 'Gujarat' : 'गुजरात'}</option>
              <option value={language === 'English' ? 'Haryana' : 'हरियाणा'}>{language === 'English' ? 'Haryana' : 'हरियाणा'}</option>
              <option value={language === 'English' ? 'Himachal Pradesh' : 'हिमाचल प्रदेश'}>{language === 'English' ? 'Himachal Pradesh' : 'हिमाचल प्रदेश'}</option>
              <option value={language === 'English' ? 'Jharkhand' : 'झारखंड'}>{language === 'English' ? 'Jharkhand' : 'झारखंड'}</option>
              <option value={language === 'English' ? 'Karnataka' : 'कर्नाटक'}>{language === 'English' ? 'Karnataka' : 'कर्नाटक'}</option>
              <option value={language === 'English' ? 'Kerala' : 'केरल'}>{language === 'English' ? 'Kerala' : 'केरल'}</option>
              <option value={language === 'English' ? 'Madhya Pradesh' : 'मध्य प्रदेश'}>{language === 'English' ? 'Madhya Pradesh' : 'मध्य प्रदेश'}</option>
              <option value={language === 'English' ? 'Maharashtra' : 'महाराष्ट्र'}>{language === 'English' ? 'Maharashtra' : 'महाराष्ट्र'}</option>
              <option value={language === 'English' ? 'Manipur' : 'मणिपुर'}>{language === 'English' ? 'Manipur' : 'मणिपुर'}</option>
              <option value={language === 'English' ? 'Meghalaya' : 'मेघालय'}>{language === 'English' ? 'Meghalaya' : 'मेघालय'}</option>
              <option value={language === 'English' ? 'Mizoram' : 'मिजोरम'}>{language === 'English' ? 'Mizoram' : 'मिजोरम'}</option>
              <option value={language === 'English' ? 'Nagaland' : 'नागालैंड'}>{language === 'English' ? 'Nagaland' : 'नागालैंड'}</option>
              <option value={language === 'English' ? 'Odisha' : 'उड़ीसा'}>{language === 'English' ? 'Odisha' : 'उड़ीसा'}</option>
              <option value={language === 'English' ? 'Punjab' : 'पंजाब'}>{language === 'English' ? 'Punjab' : 'पंजाब'}</option>
              <option value={language === 'English' ? 'Rajasthan' : 'राजस्थान'}>{language === 'English' ? 'Rajasthan' : 'राजस्थान'}</option>
              <option value={language === 'English' ? 'Sikkim' : 'सिक्किम'}>{language === 'English' ? 'Sikkim' : 'सिक्किम'}</option>
              <option value={language === 'English' ? 'Tamil Nadu' : 'तमिलनाडु'}>{language === 'English' ? 'Tamil Nadu' : 'तमिलनाडु'}</option>
              <option value={language === 'English' ? 'Telangana' : 'तेलंगाना'}>{language === 'English' ? 'Telangana' : 'तेलंगाना'}</option>
              <option value={language === 'English' ? 'Tripura' : 'त्रिपुरा'}>{language === 'English' ? 'Tripura' : 'त्रिपुरा'}</option>
              <option value={language === 'English' ? 'Uttar Pradesh' : 'उत्तर प्रदेश'}>{language === 'English' ? 'Uttar Pradesh' : 'उत्तर प्रदेश'}</option>
              <option value={language === 'English' ? 'Uttarakhand' : 'उत्तराखंड'}>{language === 'English' ? 'Uttarakhand' : 'उत्तराखंड'}</option>
              <option value={language === 'English' ? 'West Bengal' : 'पश्चिम बंगाल'}>{language === 'English' ? 'West Bengal' : 'पश्चिम बंगाल'}</option>
              <option value={language === 'English' ? 'Andaman and Nicobar Islands' : 'अंडमान और निकोबार द्वीप समूह'}>{language === 'English' ? 'Andaman and Nicobar Islands' : 'अंडमान और निकोबार द्वीप समूह'}</option>
              <option value={language === 'English' ? 'Chandigarh' : 'चंडीगढ़'}>{language === 'English' ? 'Chandigarh' : 'चंडीगढ़'}</option>
              <option value={language === 'English' ? 'Dadra and Nagar Haveli and Daman and Diu' : 'दादरा और नगर हवेली और दमन और दीव'}>{language === 'English' ? 'Dadra and Nagar Haveli and Daman and Diu' : 'दादरा और नगर हवेली और दमन और दीव'}</option>
              <option value={language === 'English' ? 'Delhi' : 'दिल्ली'}>{language === 'English' ? 'Delhi' : 'दिल्ली'}</option>
              <option value={language === 'English' ? 'Lakshadweep' : 'लक्षद्वीप'}>{language === 'English' ? 'Lakshadweep' : 'लक्षद्वीप'}</option>
              <option value={language === 'English' ? 'Puducherry' : 'पुदुच्चेरी'}>{language === 'English' ? 'Puducherry' : 'पुदुच्चेरी'}</option>
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="jilha" className="form-label">{language === "English" ? "District" : "जिल्हा"}:</label>
            <select
              id="jilha"
              name="jilha"
              value={formData.jilha}
              onChange={handleDistrictChange}
              className="form-control"
              required
            >
              <option value="">{language === "English" ? "Select District" : "जिल्हा निवडा"}</option>
              {districts.map((district) => (
                <option key={district} value={district}>
                  {district}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="taluka" className="form-label">{language === "English" ? "Taluka" : "तालुका"}:</label>
            <select
              id="taluka"
              name="taluka"
              value={formData.taluka}
              onChange={handleInputChange}
              className="form-control"
              required
            >
              <option value="">{language === "English" ? "Select Taluka" : "तालुका निवडा"}</option>
              {talukas.map((taluka) => (
                <option key={taluka} value={taluka}>
                  {taluka}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              {language === "English" ? "Email Id" : "ई - मेल आयडी"}:
            </label>
            <input
              autoComplete="off"
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              lang="en"
              placeholder={language === "English" ? "" : "कृपया तुमचा ईमेल आयडी इंग्रजीमध्ये प्रविष्ट करा."}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="telephoneNumber" className="form-label">{language === "English" ? "Telephone Number" : "दूरध्वनी क्र"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="telephoneNumber"
              name="telephoneNumber"
              value={formData.telephoneNumber}
              onChange={handleInputChange}
              inputMode="numeric"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="pincode" className="form-label">{language === "English" ? "Pincode" : "पिनकोड"}:</label>
            <input
              autoComplete="off"
              type="text"
              className="form-control"
              id="pincode"
              name="pincode"
              value={formData.pincode || ""}
              onChange={handleInputChange}
              maxLength={6}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="boardName" className="form-label">{language === "English" ? "Board Name" : "बोर्डचे नाव"}:</label>
            <input
              autoComplete="off"
              type="text"
              className="form-control"
              id="boardName"
              name="boardName"
              value={formData.boardName}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="sansthaName" className="form-label">{language === "English" ? "organization's Name (Sanstha Name)" : "संस्थेचे नाव"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="sansthaName"
              name="sansthaName"
              value={formData.sansthaName}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="indexNumber" className="form-label">{language === "English" ? "School Index Number" : "अनु क्र"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="indexNumber"
              name="indexNumber"
              value={formData.indexNumber}
              onChange={handleInputChange}
              inputMode="numeric"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="schoolCode" className="form-label">{language === "English" ? "School Code" : "शाळा कोड"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="schoolCode"
              name="schoolCode"
              value={formData.schoolCode || ""}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="sanlagnataKramank" className="form-label">{language === "English" ? "School Affiliation Code" : "संलग्नता क्र"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="sanlagnataKramank"
              name="sanlagnataKramank"
              value={formData.sanlagnataKramank}
              onChange={handleInputChange}
              inputMode="numeric"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="manyataKramank" className="form-label">{language === "English" ? "School Recognition Number" : "मान्यता क्र"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="manyataKramank"
              name="manyataKramank"
              value={formData.manyataKramank}
              onChange={handleInputChange}
              inputMode="numeric"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="madhyam" className="form-label">{language === "English" ? "Medium" : "माध्यम"}:</label>
            <input
              autoComplete="off"
              type="text"
              className="form-control"
              id="madhyam"
              name="madhyam"
              value={formData.madhyam}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="bridvakya" className="form-label">{language === "English" ? "Slogan/Mission Statement (if required for Bonafide or Leaving Certificate)" : "ब्रीद वाक्य (दाखला किंवा बोनफाईड वरती हवं असल्यास)"}:</label>
            <input
              autoComplete="off"
              lang="en"
              type="text"
              className="form-control"
              id="bridvakya"
              name="bridvakya"
              value={formData.bridvakya}
              onChange={handleInputChange}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="schoolLogo" className="form-label">{language === "English" ? "School Logo" : "शाळेचा लोगो"}:</label>
            {logoURL && <img src={logoURL} alt="School Logo" style={{ width: "100px", height: "100px" }} />}
            <input
              type="file"
              className="form-control"
              id="schoolLogo"
              name="schoolLogo"
              onChange={handleLogoChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="schoolLogo2" className="form-label">{language === "English" ? "School Logo" : "शाळेचा लोगो"}:</label>
            {logoURL2 && <img src={logoURL2} alt="School Logo" style={{ width: "100px", height: "100px" }} />}
            <input
              type="file"
              className="form-control"
              id="schoolLogo2"
              name="schoolLogo2"
              onChange={handleLogoChange2}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">{language === "English" ? "Upload Signature" : "स्वाक्षरी अपलोड करा"}:</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={handleSignatureChange}
            />
            <small style={{ display: "block", marginTop: "5px", color: "#6c757d", fontSize: "12.5px" }}>
              ℹ️ {language === "English" 
                ? "This digital signature will display on ID cards (Principal)." 
                : "ही डिजिटल स्वाक्षरी ओळखपत्रांवर (प्राचार्य) दर्शविली जाईल."}
            </small>
            {signatureURL && (
              <div className="mt-2">
                <img src={signatureURL} alt="Signature" style={{ maxHeight: "100px" }} />
              </div>
            )}
          </div>


          <button type="submit" className="btn btn-primary">{language === "English" ? "Save" : "जतन करा"}</button>
        </form>
      </div>

      <style jsx>
        {
          `
      form .form-label {
  font-weight: 600;
  color: #03365e;
  margin-bottom: 6px;
}

form .form-control {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 15px;
  transition: border 0.3s;
}

form .form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
  outline: none;
}

form select.form-control {
  background-color: #fff;
  cursor: pointer;
}

form .btn-primary {
  background-color: #03365e;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px;
  margin-top: 10px;
  transition: background-color 0.3s;
}

form .btn-primary:hover {
  background-color: #0252a2;
}

form h2 {
  font-size: 26px;
  color: #03365e;
  margin-bottom: 20px;
}

form .mb-3 {
  margin-bottom: 20px;
}

      `
        }
      </style>
    </div>
  );
}

export default SchoolData;


